import { z } from "zod";

/** `?modelo=` abre o editor a partir de um modelo pronto (T3.6). */
export const reportNewSearch = z.object({
  modelo: z
    .string()
    .regex(/^[a-z0-9-]{1,40}$/)
    .optional()
    .catch(undefined),
});

/** Impressão de etiquetas: modelo e fonte vindos da lista de produtos/contatos ou do editor. */
export const labelPrintSearch = z.object({
  modelo: z
    .string()
    .regex(/^[0-9A-HJKMNP-TV-Z]{26}$/)
    .optional()
    .catch(undefined),
  fonte: z.enum(["products", "contacts"]).optional().catch(undefined),
});
